import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import dayjs from 'dayjs';
import styles from './ProductFundraising.module.scss';
import ProductFundraisingProgress from './ProductFundraisingProgress';
import ProductFundraisingTimer from './ProductFundraisingTimer';
import { formatter } from '../utility';
import Tooltips from '@polydice/ui/dist/Tooltips';
import { BUYING_STATE } from './ProductHelper';

const ProductFundraising = ({
  product,
  fundraisingCount,
  fundraisingTotal,
  status,
  darkMode = false
}) => {
  const { funding_goal, started_at, ended_at, selling_program_id } = product;
  const isFundraisingProduct = selling_program_id === 2;
  const percentage = (fundraisingTotal / funding_goal) * 100;
  const nowDate = dayjs(new Date());
  const startDate = dayjs(started_at);
  const endDate = dayjs(ended_at);
  const isComingSoon = nowDate.isBefore(startDate);
  const [isOver, setIsOver] = useState(nowDate.isAfter(endDate));

  return (
    <section
      className={classNames(styles.productFundraising, {
        [styles.productFundraisingHidden]: status === BUYING_STATE
      })}
    >
      <div className={styles.productFundraisingHeader}>
        <h2
          className={classNames(styles.productFundraisingHeaderTitle, {
            'dark-mode gray2-bgc blue-color mobile-black': darkMode
          })}
        >
          限時獨家優惠
        </h2>
        <i
          className={`icon-info-circle-solid ${styles.productFundraisingHeaderIcon}`}
        >
          <Tooltips
            className={classNames(styles.productFundraisingHeaderIconTooltip, {
              'dark-mode gray2-bgc mobile-black': darkMode
            })}
            arrowPosition="top"
            arrowAlign="right"
          >
            愛料理市集聯合品牌推出第一手獨家商品與限時強檔優惠，集結大家的揪團力量，成功達成集氣目標，即可獲得最佳回饋方案！
          </Tooltips>
        </i>
      </div>
      {isComingSoon && (
        <div
          className={classNames(
            styles.productFundraisingTarget,
            styles.productFundraisingIsComingSoon,
            {
              'dark-mode gray2-bgc no-border': darkMode
            }
          )}
        >
          <div className={styles.productFundraisingIsComingSoon}>
            <div className={styles.productFundraisingIsComingSoonDetail}>
              <h4 className={styles.productFundraisingIsComingSoonDetailText}>
                即將上線
              </h4>
              <span className={styles.productFundraisingIsComingSoonDetailDate}>
                {startDate.format('YYYY/MM/DD')}
              </span>
            </div>
          </div>
        </div>
      )}
      {!isComingSoon && (
        <Fragment>
          <div
            className={classNames(
              styles.productFundraisingTarget,
              styles.productFundraisingIsSelling,
              {
                'dark-mode gray2-bgc mobile-black': darkMode
              }
            )}
          >
            <ProductFundraisingProgress
              radius={28}
              percentage={percentage}
              intervalTime={30}
              lineColor={darkMode ? '#527ECB' : '#f04646'}
              circleColor="#e5e5e5"
              darkMode={darkMode}
            />
            <div className={styles.productFundraisingIsSellingPrice}>
              <span
                className={classNames(
                  styles.productFundraisingIsSellingPriceTotal,
                  {
                    'dark-mode gray2-bgc mobile-black': darkMode
                  }
                )}
              >
                NT$ {formatter(fundraisingTotal)}
              </span>
              <span
                className={classNames(
                  styles.productFundraisingIsSellingPriceTarget,
                  {
                    'dark-mode gray2-bgc mobile-black': darkMode
                  }
                )}
              >
                累積銷售金額
              </span>
            </div>
          </div>
          <div className={styles.productFundraisingContainer}>
            <div className={styles.productFundraisingDetail}>
              <i
                className={`icon-user-regular ${styles.productFundraisingDetailIcon}`}
              />
              <div className={styles.productFundraisingDetailInfo}>
                <p
                  className={classNames(
                    styles.productFundraisingDetailInfoContent,
                    {
                      'dark-mode gray2-bgc mobile-black': darkMode
                    }
                  )}
                >
                  {fundraisingCount}
                </p>
                <span
                  className={classNames(
                    styles.productFundraisingDetailInfoDetail,
                    {
                      'dark-mode gray2-bgc mobile-black': darkMode
                    }
                  )}
                >
                  購買人數
                </span>
              </div>
            </div>
            {isFundraisingProduct && (
              <div className={styles.productFundraisingDetail}>
                <i
                  className={`icon-calendar-regular ${styles.productFundraisingDetailIcon}`}
                />
                <div className={styles.productFundraisingDetailInfo}>
                  {isOver ? (
                    <span className={styles.productFundraisingDetailInfoOver}>
                      已下架
                    </span>
                  ) : (
                    <div>
                      <ProductFundraisingTimer
                        className={styles.productFundraisingDetailInfoTimer}
                        endTime={ended_at}
                        timeIsUpCallback={() => setIsOver(true)}
                      />
                      <span
                        className={styles.productFundraisingDetailInfoCountdown}
                      >
                        倒數中
                      </span>
                    </div>
                  )}
                  <span className={styles.productFundraisingDetailInfoDetail}>
                    截止時間 {endDate.format('YYYY/MM/DD HH:mm')}
                  </span>
                </div>
              </div>
            )}
          </div>
        </Fragment>
      )}
    </section>
  );
};

ProductFundraising.propTypes = {
  product: PropTypes.shape({
    funding_goal: PropTypes.number.isRequired,
    started_at: PropTypes.string.isRequired,
    ended_at: PropTypes.string.isRequired,
    selling_program_id: PropTypes.number.isRequired
  }).isRequired,
  fundraisingCount: PropTypes.number.isRequired,
  fundraisingTotal: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired
};

export default ProductFundraising;
